import { useEffect, useRef } from "react";
import { useAuth } from "../stores/auth";

const ACTIVITY_EVENTS = ["mousedown", "keydown", "touchstart", "scroll"] as const;

export function useSessionIdle(): void {
  const user = useAuth((s) => s.user);
  const sessionLocked = useAuth((s) => s.sessionLocked);
  const sessionTimeoutMin = useAuth((s) => s.config?.securityPolicy?.sessionTimeoutMin ?? 0);
  const lockSession = useAuth((s) => s.lockSession);

  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!user || sessionLocked || sessionTimeoutMin <= 0) {
      if (timerRef.current != null) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      return;
    }

    const timeoutMs = sessionTimeoutMin * 60_000;

    const reset = () => {
      if (timerRef.current != null) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => {
        lockSession();
      }, timeoutMs);
    };

    reset();
    for (const event of ACTIVITY_EVENTS) {
      window.addEventListener(event, reset, { passive: true });
    }

    return () => {
      if (timerRef.current != null) window.clearTimeout(timerRef.current);
      for (const event of ACTIVITY_EVENTS) {
        window.removeEventListener(event, reset);
      }
    };
  }, [user, sessionLocked, sessionTimeoutMin, lockSession]);
}
